"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetLaborClasses = void 0;
var react_query_1 = require("react-query");
var react_1 = require("react");
var react_common_lib_1 = require("@esub-engineering/react-common-lib");
var GraphQLClient_1 = require("../../GraphQLClient");
var useGetLaborClasses = function (_a) {
    var _b, _c;
    var rateTemplateId = _a.rateTemplateId;
    var client = (0, GraphQLClient_1.useGraphQLClient)();
    var rateTemplateKey = react_common_lib_1.rateTemplateQueries.key, getRateTemplate = react_common_lib_1.rateTemplateQueries.getRateTemplate;
    var query = (0, react_1.useCallback)(function () {
        return client.request(getRateTemplate, {
            input: {
                id: rateTemplateId,
            },
        });
    }, [client, getRateTemplate, rateTemplateId]);
    var _d = (0, react_query_1.useQuery)(rateTemplateKey, query, {
        refetchOnWindowFocus: false,
        enabled: !!rateTemplateId,
    }), rateTemplateData = _d.data, error = _d.error, isLoading = _d.isLoading;
    var data = (0, react_1.useMemo)(function () {
        var _a, _b, _c;
        var activeLaborClasses = ((_c = (_b = (_a = rateTemplateData === null || rateTemplateData === void 0 ? void 0 : rateTemplateData.getRateTemplate) === null || _a === void 0 ? void 0 : _a.laborClasses) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c.filter(function (laborClass) { return laborClass.status === 'ACTIVE'; })) || [];
        return activeLaborClasses
            .filter(function (_a) {
            var laborClass = _a.laborClass;
            return laborClass.status === 'ACTIVE';
        })
            .map(function (_a) {
            var laborClass = _a.laborClass;
            return ({
                value: laborClass.id,
                text: laborClass.name,
            });
        });
    }, [(_c = (_b = rateTemplateData === null || rateTemplateData === void 0 ? void 0 : rateTemplateData.getRateTemplate) === null || _b === void 0 ? void 0 : _b.laborClasses) === null || _c === void 0 ? void 0 : _c.items]);
    return { data: data, error: error, isLoading: isLoading };
};
exports.useGetLaborClasses = useGetLaborClasses;
